import React from "react";
import { Row, Col, Image, Card } from "react-bootstrap";
import "./styles.scss";
import imageIcon from "../../assets/images/home.png";

const ReportHome = ({ image, address ,streetview=false}) => {
  console.log(image,'WWWWWW')
  const streetviewStyle={backgroundPosition:'center'}
  return (
    <>
      <Card className="shadow building-card">
        <div
          className="address-img"
          style={{
            backgroundImage: `url(${image})`,
            width: "100%",
            backgroundSize: "cover",
            height: "165px",

          }}
          className={`${streetview?'streetviewImage':''}`}
        ></div>
      </Card>
    </>
  );
};

export default ReportHome;
